import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getQuestionnaireResponseByLinkId } from 'utils';
import { useAppointmentData } from '../../../shared/stores/appointment/appointment.store';
import { InformationCard } from './InformationCard';

export const PatientDetailsContainer: FC = () => {
  const { t } = useTranslation();
  const { patient, questionnaireResponse } = useAppointmentData();

  const ethnicity = getQuestionnaireResponseByLinkId('patient-ethnicity', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const race = getQuestionnaireResponseByLinkId('patient-race', questionnaireResponse)?.answer?.[0]?.valueString;

  const pronouns = getQuestionnaireResponseByLinkId('patient-pronouns', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const pcpNumber = getQuestionnaireResponseByLinkId('pcp-number', questionnaireResponse)?.answer?.[0]?.valueString;
  const pcpAddress = getQuestionnaireResponseByLinkId('pcp-address', questionnaireResponse)?.answer?.[0]?.valueString;
  const pcpPractice = getQuestionnaireResponseByLinkId('pcp-practice', questionnaireResponse)?.answer?.[0]?.valueString;
  const pcpFirstName = getQuestionnaireResponseByLinkId('pcp-first', questionnaireResponse)?.answer?.[0]?.valueString;
  const pcpLastName = getQuestionnaireResponseByLinkId('pcp-last', questionnaireResponse)?.answer?.[0]?.valueString;
  const pcpFirstAndLastName = pcpFirstName && pcpLastName ? `${pcpLastName}, ${pcpFirstName}` : undefined;

  const howDidYouHearAboutUs = patient?.extension?.find(
    (e) => e.url === 'https://fhir.zapehr.com/r4/StructureDefinitions/point-of-discovery'
  )?.valueString;

  const preferredLanguage = getQuestionnaireResponseByLinkId('preferred-language', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  const requireRelayService = getQuestionnaireResponseByLinkId('relay-phone', questionnaireResponse)?.answer?.[0]
    ?.valueString;

  return (
    <InformationCard
      title={t('patientDetails.title', 'Patient details')}
      fields={[
        {
          label: t('patientDetails.ethnicity', "Patient's ethnicity"),
          value: ethnicity,
        },
        {
          label: t('patientDetails.race', "Patient's race"),
          value: race,
        },
        {
          label: t('patientDetails.pronouns', 'Preferred pronouns'),
          value: pronouns,
        },
        {
          label: t('patientDetails.pcpName', 'PCP first and last name'),
          value: pcpFirstAndLastName,
        },
        {
          label: t('patientDetails.pcpPractice', 'PCP Practice name'),
          value: pcpPractice,
        },
        {
          label: t('patientDetails.pcpAddress', 'PCP address'),
          value: pcpAddress,
        },
        {
          label: t('patientDetails.pcpNumber', 'PCP phone number'),
          value: pcpNumber,
        },
        {
          label: t('patientDetails.howDidYouHear', 'How did you hear about us?'),
          value: howDidYouHearAboutUs,
        },
        {
          label: t('patientDetails.preferredLanguage', 'Preferred language'),
          value: preferredLanguage,
        },
        {
          label: t('patientDetails.relayService', 'Do you require a Hearing Impaired Relay Service? (711)'),
          value: requireRelayService,
        },
      ]}
    />
  );
};
